module.exports = "<div id=\"callbackPrompt\">\n  <h4 class=\"mat-subheading-1\" >\n    Loading...\n  </h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/app/callback/callback.component.html
// module id = ../../../../../src/app/callback/callback.component.html
// module chunks = main